import { faTruckFast } from "@fortawesome/pro-regular-svg-icons";
import { ColumnLayout } from "@mittwald/flow-components/dist/components/ColumnLayout";
import { useFormContext } from "@mittwald/flow-components/dist/components/Form";
import { Section } from "@mittwald/flow-components/dist/components/Section";
import Select from "@mittwald/flow-components/dist/components/Select/Select";
import { TextLink } from "@mittwald/flow-components/dist/components/TextLink";
import TranslationProvider from "@mittwald/flow-components/dist/components/TranslationProvider/TranslationProvider";
import React from "react";
import type { RelocationApiData } from "../../../../../../model/relocation/Relocation";
import { ProjectInformationBanner } from "../../ProjectInformationBanner/ProjectInformationBanner";
import { StepHeaderItem } from "../../StepHeaderItem";
import { isMStudioTariff, TariffType } from "./utils/TariffUtils";

interface TargetStepContentProps {
  availableTariffs?: string[];
}

export const TariffStepContent: React.FC<TargetStepContentProps> = (props) => {
  const form = useFormContext<RelocationApiData>();
  const tariffType = form.watch("target.product") as TariffType;
  const tariffs = props.availableTariffs || Object.values(TariffType);
  const selectOptions = tariffs.map((tariff) => ({
    label: tariff,
    value: tariff,
  }));

  React.useEffect(() => {
    if (isMStudioTariff(tariffType)) {
      form.setValue("target.system", "mstudio");
      form.setValue("target.projectName", "");
    } else {
      form.setValue("target.organisation", "-");
      form.setValue("target.system", "kc");
    }
  }, [tariffType]);

  return (
    <TranslationProvider name="tariffStepContent" type="component">
      <Section.Layout>
        <StepHeaderItem
          description="description"
          headline="headline"
          headlineIcon={faTruckFast}
        />
        <Section.Item>
          <ColumnLayout>
            <Select
              label="productSelection"
              name="target.product"
              options={selectOptions}
              rules={{
                required: true,
              }}
            />
            <ProjectInformationBanner />
          </ColumnLayout>
          <TextLink
            action="https://mittwald.de/?etcc_med=SEA&etcc_par=Google&etcc_cmp=17238358468&etcc_grp=140304729247&etcc_bky=mittwald&etcc_mty=e&etcc_plc=&etcc_ctv=533800527304&etcc_bde=c&etcc_var=EAIaIQobChMI7YvN6pbf-AIVQZ_VCh3jEQ94EAAYASAAEgJqPvD_BwE"
            i18n="tariffOverview"
          />
        </Section.Item>
      </Section.Layout>
    </TranslationProvider>
  );
};
